import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import { API } from "../../backend";
import authHeader from "../../services/auth-header";

function AddRequest() {

    const navigate = useNavigate();

    const [workflowOptions, setWorkflowOptions] = useState([]);

    const [requestData, setRequestData] = useState({
        workflow: "",
        description: ""
    });

    useEffect(() => {
        loadWorkflows();
    }, []);

    const loadWorkflows = async () => {
        try {

            const res = await axios.get(
                API + "approvals/workflows/",
                { headers: authHeader() }
            );

            setWorkflowOptions(res.data || []);

        } catch (err) {
            console.error(err);
        }
    };

    const handleChange = (e) => {

        const { name, value } = e.target;

        setRequestData({
            ...requestData,
            [name]: value
        });
    };

    const handleSave = async () => {

        if (!requestData.workflow) {
            toast.error("Workflow is required");
            return;
        }

        try {

            const res = await axios.post(
                API + "approvals/create/",
                requestData,
                { headers: authHeader() }
            );

            toast.success(
                "Request Created (ID: " + res.data.request_id + ")"
            );

            setTimeout(() => {
                navigate("/approvals");
            }, 1200);

        } catch (err) {

            console.error(err);
            toast.error("Failed to create request");

        }
    };

    return (

        <div className="page-wrapper">

            <ToastContainer />

            <div className="content container-fluid">

                <div className="header pt-3 mb-3">
                    <h5>Approvals</h5>
                    <h6>
                        <Link to="/approvals">Approvals</Link>
                        {" / "}
                        Add Request
                    </h6>
                </div>

                <div className="card">
                    <div className="card-body">

                        <div className="row">

                            <div className="col-md-6">

                                <label className="form-label">
                                    Workflow
                                </label>

                                <select
                                    className="form-control"
                                    name="workflow"
                                    value={requestData.workflow}
                                    onChange={handleChange}
                                >

                                    <option value="">
                                        Select Workflow
                                    </option>

                                    {workflowOptions.map((w) => (
                                        <option key={w.id} value={w.id}>
                                            {w.name}
                                        </option>
                                    ))}

                                </select>

                            </div>

                            <div className="col-md-12 mt-3">

                                <label className="form-label">
                                    Description
                                </label>

                                <textarea
                                    className="form-control"
                                    name="description"
                                    rows="3"
                                    value={requestData.description}
                                    onChange={handleChange}
                                />

                            </div>

                        </div>

                        <div className="mt-4">

                            <button
                                className="btn btn-secondary"
                                onClick={() => navigate("/approvals")}
                            >
                                Cancel
                            </button>

                            &nbsp;

                            <button
                                className="btn btn-primary"
                                onClick={handleSave}
                            >
                                Save
                            </button>

                        </div>

                    </div>
                </div>

            </div>

        </div>
    );
}

export default AddRequest;